import React from 'react';
import { Form, Input, DatePicker, Row, Col, Card, Typography } from 'antd';
import type { FormInstance } from 'antd';
import dayjs from 'dayjs';
import { InternalNotesField } from '../Shared/InternalNotesField';

const { Text } = Typography;

export interface EstimateNotesSectionProps {
  form: FormInstance;
  isMobile: boolean;
  /** Internal notes value (C2-T20). */
  internalNotes?: string;
  /** Callback when internal notes change (C2-T20). */
  onInternalNotesChange?: (v: string) => void;
}

/**
 * Estimate scheduling + notes (Valid Until, Customer Notes, Internal Notes).
 *
 * Lives in the scrollable body of EstimateForm — moved out of the sticky footer so the
 * footer stays a slim action bar (totals + Save/Send) and the Service Items table keeps
 * its vertical space. This is the ONLY <Form form={form}> in the estimate create/edit
 * screen, so the form fields (valid_until, customer_notes) bind here.
 */
export const EstimateNotesSection: React.FC<EstimateNotesSectionProps> = ({
  form,
  isMobile,
  internalNotes,
  onInternalNotesChange,
}) => {
  const inputStyle = { fontSize: 16 };

  return (
    <Card
      size="small"
      style={{ marginTop: 12 }}
      styles={{ body: { padding: isMobile ? 12 : 16 } }}
      title={<Text strong style={{ fontSize: 13 }}>Details & Notes</Text>}
    >
      <Form form={form} layout="vertical">
        <Row gutter={[16, 12]}>
          <Col xs={24} sm={8} md={6}>
            <Form.Item
              label={<span style={{ fontSize: 12, fontWeight: 500 }}>Valid Until</span>}
              name="valid_until"
              initialValue={dayjs().add(14, 'days')}
              style={{ marginBottom: 0 }}
            >
              <DatePicker style={{ width: '100%', ...inputStyle }} placeholder="2 weeks" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={16} md={18}>
            <Form.Item
              label={<span style={{ fontSize: 12, fontWeight: 500 }}>Customer Notes</span>}
              name="customer_notes"
              style={{ marginBottom: 0 }}
            >
              <Input.TextArea rows={2} placeholder="Notes for customer..." style={inputStyle} />
            </Form.Item>
          </Col>
          {onInternalNotesChange !== undefined && (
            <Col xs={24}>
              <InternalNotesField
                value={internalNotes ?? ''}
                onChange={onInternalNotesChange}
                rows={2}
              />
            </Col>
          )}
        </Row>
      </Form>
    </Card>
  );
};

export default EstimateNotesSection;
